import Mailcheck from 'mailcheck';

const addSuggestion = (element: HTMLInputElement, newElement: HTMLElement) => {
  if (!element.parentNode) {
    return;
  }

  element.classList.add('email-suggestion-input');

  if (element.nextSibling) {
    element.parentNode.insertBefore(newElement, element.nextSibling);
  } else {
    element.parentNode.appendChild(newElement);
  }
};

const clearSugggestions = () => {
  const inputs = document.getElementsByClassName('email-suggestion-input');
  for (let i = 0; i < inputs.length; i += 1) {
    const el = inputs[i];
    el.classList.remove('email-suggestion-input');
  }

  const suggestions = document.getElementsByClassName('email-suggestion');
  for (let i = 0; i < suggestions.length; i += 1) {
    const el = suggestions[i];
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

export const sanitize = (email: string): string =>
  email
    .replace(/@(\w+).(come|comm|vom|comcom|con|comp|cin)$/, (m, $1: string) => `@${$1}.com`)
    .replace(/@(\w+).(ner|ney)$/, (m, $1: string) => `@${$1}.net`)
    .replace('@ail', '@aol')
    .replace('@concast', '@comcast')
    .replace('@g.mail', '@gmail')
    .replace('@gail', '@gmail')
    .replace('@gamail', '@gmail')
    .replace('@gamil', '@gmail')
    .replace('@gmaiil', '@gmail')
    .replace('@gmil', '@gmail')
    .replace('@gmsil', '@gmail')
    .replace('@gnail', '@gmail')
    .replace('@hotmal', '@hotmail')
    .replace('@hotmsil', '@hotmail')
    .replace('@hotnail', '@hotmail')
    .replace('@icould', '@icloud')
    .replace('@yshoo', '@yahoo')
    .replace('@yyahoo', '@yahoo')
    .replace(';', '.')
    .replace(',', '.')
    .replace(/[(.|,|\s)]*@/, '@')
    .replace(/@[(.|,|\s)]*/, '@')
    .replace(/[.]$/, '')
    .replace(/^[.]/, '')
    .replace(/[.][.]/, '.')
    .replace(/[\s]/, '');

type Suggestion = { full: string };

const createSuggestionField = (emailField: HTMLInputElement, { full }: Suggestion) => {
  const suggestionField = document.createElement('a');
  const sanitizedEmail = sanitize(full);
  suggestionField.classList.add('email-suggestion');
  suggestionField.innerText = `Did you mean ${sanitizedEmail}?`;
  suggestionField.onclick = () => {
    emailField.value = sanitizedEmail;
    emailField.dispatchEvent(new Event('input'));
    clearSugggestions();
  };
  return suggestionField;
};

const processSuggestion = (emailField: HTMLInputElement, suggestion: Suggestion) => {
  clearSugggestions();
  const suggestionField = createSuggestionField(emailField, suggestion);
  addSuggestion(emailField, suggestionField);
};

const handle = (emailField: HTMLInputElement): void => {
  const email = sanitize(emailField.value);
  Mailcheck.run({
    email,
    suggested: (suggestion: Suggestion) => processSuggestion(emailField, suggestion),
    empty: () => {
      clearSugggestions();
      if (email !== emailField.value) {
        processSuggestion(emailField, { full: email });
      }
    },
  });
};

export const suggestify = (emailField: HTMLInputElement): void => {
  emailField.addEventListener('keyup', () => {
    handle(emailField);
  });
  emailField.addEventListener('change', () => {
    handle(emailField);
  });
};

export const suggestifyEmails = (): void => {
  const emailField = document.querySelectorAll<HTMLInputElement>('input[type=email]');
  emailField.forEach((field) => suggestify(field));
};
